import React, { useEffect, useRef } from 'react';
import { css } from 'styled-components';
import { UitkIcon } from 'uitk-react-icons';
import { LozengeMessageV2Props } from 'src/components/common/module-util';
import Layout from 'src/components/common/theme/Layout';
import { checkValue } from 'src/components/common/helper';

const LozengeMessageV2 = (props: LozengeMessageV2Props) => {
  const brandStyle = checkValue(props?.iconStyle) && props.iconStyle === 'Brand';
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && tooltipRef.current) {
        tooltipRef.current.style.transform = 'scale(0)';
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const showTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.style.transform = 'scale(1)';
    }
  };

  const hideTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.style.transform = 'scale(0)';
    }
  };

  const moduleCss = () => {
    return `
          ${
            checkValue(props?.backgroundColor)
              ? `
                .lozenge-message-v2-container .info-description {
                    background-color: ${props?.backgroundColor} !important;
                }
                .lozenge-message-v2-container .info-description:before {
                    border-bottom: 10px solid ${props?.backgroundColor} !important;
                }
              `
              : ''
          }
          ${
            checkValue(props?.color)
              ? `
                .lozenge-message-v2-container button {
                    background-color: transparent;
                }
                .lozenge-message-v2-container .info-description p {
                    color: ${props?.color} !important;
                }
                .lozenge-message-v2-container svg {
                    color: ${props?.color} !important;
                }
              `
              : checkValue(props?.defaultTextColor)
              ? `
                .lozenge-message-v2-container .info-description p {
                    color: ${props?.defaultTextColor?.toLowerCase() === 'dark' ? '#141D38' : '#ffffff'} !important;
                }
                .lozenge-message-v2-container svg {
                    color: ${props?.defaultTextColor?.toLowerCase() === 'dark' ? '#141D38' : '#ffffff'} !important;
                }
              `
              : ''
          }
          ${
            checkValue(props?.iconColor)
              ? `
              .lozenge-message-v2-container svg {
                  color: ${props?.iconColor} !important;
                }
              `
              : ''
          }
        `;
  };

  return checkValue(props?.lozengeDetailMessage) ? (
    <Layout
      HtmlTag="div"
      className="lozenge-message-v2"
      css={css`
        ${moduleCss()}
      `}
    >
      <div
        className={`lozenge-message-v2-container ${checkValue(props?.exClass) ? props.exClass : ''}`}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        <div
          // aria-describedby="tooltip-info"
          aria-labelledby="tooltip-info"
          // aria-label= { props.lozengeDetailMessage }
          onFocus={showTooltip}
          onBlur={hideTooltip}
          tabIndex={0}
          className={`info-icon-container ${checkValue(props?.iconStyle) ? props.iconStyle : ''}`}
          role="tooltip"
        >
          <UitkIcon name={brandStyle ? 'info' : 'info_outline'} className={`info-icon`} />
        </div>
        <div ref={tooltipRef} className="info-description" id="tooltip-info" role="tooltip" aria-label={ props.lozengeDetailMessage }>
          <p dangerouslySetInnerHTML={{ __html: props.lozengeDetailMessage }}></p>
        </div>
      </div>
    </Layout>
  ) : null;
};

export default LozengeMessageV2;
